export default __webpack_public_path__ + "static/image24-e77e623c29fcc2945c3935a625d088ab.gif";